import { IDepartmentPermissionInitialState } from "../../../types/permissions/departmentInterface";
import { DepartmentPermissionActionTypes, DepartmentPermissionActions } from "../../actionTypes/permissions/departmentPermissionTypes";


const initialState: IDepartmentPermissionInitialState = {
  departmentPermissionList: [],
  departmentPermissionPageCount: 0,
};

export default function departmentPermissionReducer(state = initialState, action: DepartmentPermissionActionTypes): IDepartmentPermissionInitialState {
  switch (action.type) {
    case DepartmentPermissionActions.SET_DEPARTMENT_PERMISSION_LIST:
      return {
        ...state,
        departmentPermissionList: action.payload,
      };

    case DepartmentPermissionActions.SET_DEPARTMENT_PERMISSION_PAGE_COUNT:
      return {
        ...state,
        departmentPermissionPageCount: action.payload
      };


    default:
      return state;
  }
}
